/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DamageGroup;
(function (DamageGroup) {
    DamageGroup["Window"] = "Window";
    DamageGroup["Rim"] = "Rim";
    DamageGroup["Tire"] = "Tire";
    DamageGroup["Body"] = "Body";
    DamageGroup["Lights"] = "Lights";
})(DamageGroup || (DamageGroup = {}));
export function DamageGroupFromJSON(json) {
    return DamageGroupFromJSONTyped(json, false);
}
export function DamageGroupFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DamageGroupToJSON(value) {
    return value;
}
